var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dovResource" },
    _vm._l(_vm.doc, function (item, index) {
      return _c("div", { key: index }, [
        _c("iframe", {
          class: item.type == "课件" ? "webOffice365 ppt" : "webOffice365",
          attrs: {
            src: `//ow365.cn/?i=${_vm.institutionConfig.webOffice365Account}&furl=${item.encryptionUrl}`,
            width: "100%",
            frameborder: "0",
          },
        }),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resource/docResource.vue?vue&type=template&id=d5946316&
// module id = null
// module chunks = 